import React from "react";

const StaticsIcons = ({ height = 24, width = 24, color = "#000" }) => {
  return (
    <>
      <svg
        width={width}
        height={height}
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M15.324 1.51734C15.7412 1.27189 16.2588 1.27189 16.676 1.51734L28.0094 8.18401C28.4166 8.42357 28.6667 8.86077 28.6667 9.33325V22.6666C28.6667 23.1391 28.4166 23.5763 28.0094 23.8158L16.676 30.4825C16.2588 30.7279 15.7412 30.7279 15.324 30.4825L3.99064 23.8158C3.58339 23.5763 3.33334 23.1391 3.33334 22.6666V9.33325C3.33334 8.86077 3.58339 8.42357 3.99064 8.18401L15.324 1.51734ZM6 10.0958V21.904L16 27.7863L26 21.904V10.0958L16 4.21349L6 10.0958Z"
          fill={color}
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M21.3333 10.6667C22.0697 10.6667 22.6667 11.2637 22.6667 12.0001V20.0001C22.6667 20.7365 22.0697 21.3334 21.3333 21.3334C20.597 21.3334 20 20.7365 20 20.0001V12.0001C20 11.2637 20.597 10.6667 21.3333 10.6667ZM16 13.3334C16.7364 13.3334 17.3333 13.9304 17.3333 14.6667V20.0001C17.3333 20.7365 16.7364 21.3334 16 21.3334C15.2636 21.3334 14.6667 20.7365 14.6667 20.0001V14.6667C14.6667 13.9304 15.2636 13.3334 16 13.3334ZM10.6667 16.0001C11.403 16.0001 12 16.597 12 17.3334V20.0001C12 20.7365 11.403 21.3334 10.6667 21.3334C9.93029 21.3334 9.33334 20.7365 9.33334 20.0001V17.3334C9.33334 16.597 9.93029 16.0001 10.6667 16.0001Z"
          fill={color}
        />
      </svg>
    </>
  );
};

export default StaticsIcons;
